import { useEffect, useState } from "react";
import {
  FaClock,
  FaComments,
  FaExclamationTriangle,
  FaFileInvoiceDollar
} from "react-icons/fa";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Loading } from "../shared/loading/Loading";
import { CookieConsent } from "../cookie/CookieConsent";
import { Link } from "react-router-dom";
import { usePendencias } from "../../hooks/useFornecedores";
import { useAuth } from "../../contexts/AuthContext";
import Style from "./index.module.css";

export const Home = () => {
  const { user } = useAuth();
  const [isMobile, setIsMobile] = useState(false);

  const {
    // propostas pendentes com resposta
    propostasPendentesComResposta,
    setPagePropostasPendentesComResposta,
    totalPagesPropostasPendentesComResposta,
    pagePropostasPendentesComResposta,
    // propostas pendentes sem resposta
    propostasPendentesSemResposta,
    setPagePropostasPendentesSemResposta,
    totalPagesPropostasPendentesSemResposta,
    pagePropostasPendentesSemResposta,
    isLoading,
  } = usePendencias(user);

  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth < 768);
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  if (user.tipusu === "COMPRADOR" && isLoading)
    return <Loading text="Carregando dados..." />;

  return (
    <main className={Style.home}>
      {user.tipusu === "FORNECEDOR" && (
        <CookieConsent />
      )}
      {user.tipusu === "COMPRADOR" && (
        <h2>
          <FaFileInvoiceDollar style={{ marginRight: 8 }} /> Propostas
        </h2>
      )}
      <section className={Style.gridContainerFornecedor}>
        <div className={Style.gridCard}>
          <h3>
            <FaComments /> Propostas Respondidas
            <p>({propostasPendentesComResposta?.total ?? 0} fornecedores)</p>
          </h3>
          <ul>
            {propostasPendentesComResposta?.docs?.length > 0 ? (
              propostasPendentesComResposta.docs.map((item, i) => (
                <li key={i}>
                  <Link
                    to={`/propostas/${item.ordcom}`}
                    className={Style.link}
                  >
                    Ordem de Compra - {item.ordcom} ({item.datpro})
                  </Link>
                </li>
              ))
            ) : (
              <li>Nenhuma proposta respondida</li>
            )}
          </ul>

          {totalPagesPropostasPendentesComResposta > 1 && (
            <div className={Style.pagination}>
              <div className={Style.paginationControls}>
                <button onClick={() => setPagePropostasPendentesComResposta((p) => Math.max(p - 1, 1))} disabled={pagePropostasPendentesComResposta === 1}>
                  {isMobile ? <ChevronLeft size={16} /> : "‹"}
                </button>
                <button onClick={() => setPagePropostasPendentesComResposta((p) => Math.min(p + 1, totalPagesPropostasPendentesComResposta))} disabled={pagePropostasPendentesComResposta === totalPagesPropostasPendentesComResposta}>
                  {isMobile ? <ChevronRight size={16} /> : "›"}
                </button>
              </div>
              <span className={Style.paginationInfo}>Página {pagePropostasPendentesComResposta} de {totalPagesPropostasPendentesComResposta}</span>
            </div>
          )}
        </div>

        {
          user.tipusu === 'FORNECEDOR' ? (
            <div className={Style.gridCard}>
              <h3>
                <FaExclamationTriangle /> Avisos
                <p>Avisos do sistema</p>
              </h3>
              <ul>
                {
                  user.status === 'QUESTIONARIO_PENDENTE' ? (
                    <li>
                      <Link
                        to={`/fornecedores/${user.codope}`}
                        className={Style.link}
                      >
                        Seu questionário está pendente de resposta!
                      </Link>
                    </li>
                  ) : (
                    <li>Nenhum aviso </li>
                  )
                }
              </ul>
            </div>
          ) :
            <div className={Style.gridCard}>
              <h3>
                <FaClock /> Propostas Pendentes
                <p>({propostasPendentesSemResposta?.total ?? 0} fornecedores)</p>
              </h3>
              <ul>
                {propostasPendentesSemResposta?.docs?.length > 0 ? (
                  propostasPendentesSemResposta.docs.map((item, i) => (
                    <li key={i}>
                      <Link
                        to={`/propostas/${item.ordcom}`}
                        className={Style.link}
                      >
                        Ordem de Compra - {item.ordcom} ({item.datpro})
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Nenhuma proposta sem resposta</li>
                )}
              </ul>

              {totalPagesPropostasPendentesSemResposta > 1 && (
                <div className={Style.pagination}>
                  <div className={Style.paginationControls}>
                    <button onClick={() => setPagePropostasPendentesSemResposta((p) => Math.max(p - 1, 1))} disabled={pagePropostasPendentesSemResposta === 1}>
                      {isMobile ? <ChevronLeft size={16} /> : "‹"}
                    </button>
                    <button onClick={() => setPagePropostasPendentesSemResposta((p) => Math.min(p + 1, pagePropostasPendentesSemResposta))} disabled={pagePropostasPendentesSemResposta === totalPagesPropostasPendentesSemResposta}>
                      {isMobile ? <ChevronRight size={16} /> : "›"}
                    </button>
                  </div>
                  <span className={Style.paginationInfo}>Página {pagePropostasPendentesSemResposta} de {totalPagesPropostasPendentesSemResposta}</span>
                </div>
              )}
            </div>
        }
      </section>
    </main>
  );
};